var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron d-flex min-vh-100",class:_vm.isAligned ? 'align-items-center' : ''},[_c('div',{staticClass:"container text-center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }